<template>
  <div class="text-center">
    <h1>{{ this.title }}</h1>
    <img :src="this.logo" alt="" srcset="">
    <h2>{{ this.description }}</h2>
  </div>
</template>

<script>
  import logo from "@/assets/logo.png"
  export default {
    name: 'Home',
    data() {
      return {
        title: "Admin Portal",
        description: "Walk Online Mobile Manager",
        logo: logo
      }
    }
  }
</script>
